var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { cls_tabs_base, cls_tabs_trigger, cls_tabs_list, cls_tabs_content, cls_tabs_trigger_contains_error, } from "./tabs.css";
import { join } from "../helpers";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { useif } from "framework/state/types";
var Tabs = function (props) {
    var cls = join(cls_tabs_base, props.class);
    return React.createElement(TabsPrimitive.Root, __assign({}, props, { className: cls }));
};
var TabsTrigger = function (props) {
    var containsError = props.containsError, otherProps = __rest(props, ["containsError"]);
    var cls = join(cls_tabs_trigger, useif(containsError, cls_tabs_trigger_contains_error));
    return React.createElement(TabsPrimitive.Trigger, __assign({}, otherProps, { className: cls }));
};
var TabsList = function (props) {
    return React.createElement(TabsPrimitive.List, __assign({}, props, { className: cls_tabs_list }));
};
var TabsContent = function (props) {
    var cls = join(cls_tabs_content, props.className);
    return React.createElement(TabsPrimitive.Content, __assign({}, props, { className: cls }));
};
export { Tabs, TabsTrigger, TabsList, TabsContent, };
